module.exports = __webpack_public_path__ + "static/creator-tokens-background-b6f83568ca3fb201f6d879fe1d879d8e.png";